var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2522_5542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
    stroke: "#222222",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97461 4.85742C7.7207 4.85742 7.50391 4.77344 7.32422 4.60547C7.14844 4.43359 7.06055 4.22461 7.06055 3.97852C7.06055 3.72852 7.15039 3.51758 7.33008 3.3457C7.50977 3.16992 7.72461 3.08203 7.97461 3.08203C8.22461 3.08203 8.43945 3.16992 8.61914 3.3457C8.79883 3.51758 8.88867 3.72852 8.88867 3.97852C8.88867 4.22461 8.79883 4.43359 8.61914 4.60547C8.44336 4.77344 8.22852 4.85742 7.97461 4.85742ZM6.48047 11.3555C6.84375 11.3555 7.07031 11.3223 7.16016 11.2559C7.25391 11.1855 7.31055 11.1113 7.33008 11.0332C7.34961 10.9551 7.35938 10.8574 7.35938 10.7402V7.51172C7.35938 7.23047 7.33398 7.04688 7.2832 6.96094C7.23633 6.875 7.10547 6.83203 6.89062 6.83203H6.46875V6.1875C6.85156 6.1875 7.15234 6.16016 7.37109 6.10547C7.58984 6.04688 7.74414 6.00586 7.83398 5.98242C7.92383 5.95508 8.02148 5.94141 8.12695 5.94141C8.33008 5.94141 8.46289 6.00195 8.52539 6.12305C8.5918 6.24023 8.625 6.42969 8.625 6.69141V10.7402C8.625 10.9863 8.66406 11.1406 8.74219 11.2031C8.875 11.3047 9.12695 11.3555 9.49805 11.3555V12H6.48047V11.3555Z",
    fill: "#222222",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_5542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.b649c6cec1fcc905754bb01fe4719874.svg";
export { ForwardRef as ReactComponent };